import { gql } from '@apollo/client';
import React from 'react';
import { Breadcrumbs, Breadcrumb, useBreakpoint } from '@moda/om';
import { titleize } from '../../lib/titleize';
import { hrefFor } from '../../routers';
import { VERTICALS, Vertical } from '../../constants';
import { ProductBreadcrumbsFragment } from '../../generated/types/ProductBreadcrumbsFragment';

export const PRODUCT_BREADCRUMBS_FRAGMENT = gql`
  fragment ProductBreadcrumbsFragment on Variant {
    gender
    category
    subcategory
    name
  }
`;

interface Props {
  variant: ProductBreadcrumbsFragment;
}

const section = 'shop';

export const ProductBreadcrumbs: React.FC<Props> = React.memo(({ variant }) => {
  const { gender, category: categories, subcategory: subcategories, name } = variant;
  const vertical = VERTICALS[gender as Vertical];

  const category = categories[0];
  const subcategory = subcategories[0];

  const { matches: displayProductTitle } = useBreakpoint({ gt: 'sm' });

  return (
    <Breadcrumbs>
      <Breadcrumb to={hrefFor.HomePage({ vertical })}>{titleize(vertical)}</Breadcrumb>

      {category && (
        <Breadcrumb to={hrefFor.ProductCategoryListingPage({ vertical, section, category })}>
          {titleize(category)}
        </Breadcrumb>
      )}

      {category && subcategory && (
        <Breadcrumb
          to={hrefFor.ProductCategoryListingPage({
            vertical,
            section,
            category,
            subcategory
          })}
        >
          {titleize(subcategory)}
        </Breadcrumb>
      )}

      {displayProductTitle && <Breadcrumb>{name}</Breadcrumb>}
    </Breadcrumbs>
  );
});
